// extracted by mini-css-extract-plugin
export default {"relaxTypo":"calculate_relaxTypo__WhDC2","question":"calculate_question__1xI2z","answer":"calculate_answer__gdgn4"};